import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  botoesFormulario: {
    marginTop: theme.spacing(3),
  },
}))
